import {
  CANVAS_CREATOR,
  CANVAS_STUDENT,
  GCLASSROOM_CLASSWORK,
  GCLASSROOM_HOME
} from '@mote/helpers/constants'
import { UrlPattern } from '@mote/helpers/url'

export const urlPatterns = [
  new UrlPattern(
    /(https:\/\/classroom\.google\.com)((\/u\/\d)?\/c\/\w+)$/,
    GCLASSROOM_HOME
  ),
  new UrlPattern(
    /(https:\/\/classroom\.google\.com)((\/u\/\d)?\/w\/\w+\/t\/all)$/,
    GCLASSROOM_CLASSWORK
  )
]

export const canvasCreatorUrlPattern = new UrlPattern(
  /(https:\/\/(.+)\.instructure\.com)(\/courses\/(\d+)\/gradebook\/speed_grader\?assignment_id=(\d+)&student_id=(\d+))$/,
  CANVAS_CREATOR
)
export const canvasStudentUrlPattern = new UrlPattern(
  /(https:\/\/(.+)\.instructure\.com)(\/courses\/(\d+)\/assignments\/(\d+)\/submissions\/(\d+))$/,
  CANVAS_STUDENT
)
